import React, { useState, useCallback, useMemo, useRef, useEffect } from 'react';
import { Box, Typography, CircularProgress, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import api from '../services/api';
import { HeaderIOS, IOS } from './shared/MenuLayout';
import {
  Chart as ChartJS, CategoryScale, LinearScale,
  BarElement, Tooltip as CTooltip, Legend
} from 'chart.js';
import { Bar, Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, CTooltip, Legend);

const hoy = () => { const d=new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; };
const primerDiaMes = () => { const d=new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-01`; };

const TH = ({children,right,center,w}) => (
  <th style={{padding:'9px 10px',width:w,textAlign:right?'right':center?'center':'left',
    fontSize:'0.6rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.06em',
    textTransform:'uppercase',backgroundColor:IOS.surface,
    borderBottom:`1px solid ${IOS.separator}`,whiteSpace:'nowrap',
    position:'sticky',top:0,zIndex:1}}>{children}</th>
);

const KpiCard = ({label,valor,color,icon}) => (
  <Box sx={{bgcolor:IOS.surface,borderRadius:'14px',p:1.8,flex:1,
  border:`1px solid ${IOS.separator}`,boxShadow:'0 1px 4px rgba(0,0,0,0.06)'}}>
    <Box sx={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:1}}>
      <Box>
        <Typography sx={{fontSize:'0.58rem',fontWeight:700,color:IOS.label2,
          letterSpacing:'0.07em',textTransform:'uppercase',mb:0.5}}>{label}</Typography>
        <Typography sx={{fontWeight:800,fontSize:'1.4rem',color,
          fontVariantNumeric:'tabular-nums',lineHeight:1}}>
          {Number(valor).toLocaleString('es-PE')}
        </Typography>
      </Box>
      <Box sx={{width:36,height:36,borderRadius:'10px',bgcolor:`${color}12`,
        display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
        {icon}
      </Box>
    </Box>
  </Box>
);

const KardexFarmacia = ({modulo='seguros'}) => {
  const navigate   = useNavigate();
  const user       = authService.getCurrentUser();
  const ueId       = user?.ueIdEstablecimiento||user?.UeIdEstablecimiento||0;
  const nf         = user?.nombreCompleto||user?.usuario||'';
  const handleLogout = () => { authService.logout(); navigate('/login'); };

  const [fechaInicio, setFechaInicio] = useState(primerDiaMes());
  const [fechaFin,    setFechaFin]    = useState(hoy());
  const [fuente,      setFuente]      = useState('');

  const [busq,        setBusq]        = useState('');
  const [productos,   setProductos]   = useState([]);
  const [cargProd,    setCargProd]    = useState(false);
  const [prodSel,     setProdSel]     = useState(null);
  const [showDrop,    setShowDrop]    = useState(false);

  const [datos,       setDatos]       = useState([]);
  const [totalPrescritoReal,    setTotalPrescritoReal]    = useState(0);
const [prescritoPorServicio,  setPrescritoPorServicio]  = useState([]);
  const [cargando,    setCargando]    = useState(false);
  const [buscado,     setBuscado]     = useState(false);
  const [busqTabla,      setBusqTabla]      = useState('');
  const [filtroFin,      setFiltroFin]      = useState('');
  const [tipoGrafKardex, setTipoGrafKardex] = useState('bar');
  const timerBusq = useRef(null);
  const dropRef   = useRef(null);

  // Cerrar dropdown al click afuera
  useEffect(() => {
    const h = e => { if(dropRef.current&&!dropRef.current.contains(e.target)) setShowDrop(false); };
    document.addEventListener('mousedown',h);
    return ()=>document.removeEventListener('mousedown',h);
  },[]);

  const buscarProductos = useCallback(async (q) => {
    if(!q||q.length<1){ setProductos([]); return; }
    setCargProd(true);
    try {
      const r = await api.get('/seguros/kardex/buscar-productos',{params:{ueId,filtro:q}});
      if(r.data.success) setProductos(r.data.data||[]);
    } catch(e){console.error(e);}
    finally{ setCargProd(false); }
  },[ueId]);

  const handleBusq = e => {
    const v = e.target.value;
    setBusq(v); setShowDrop(true); setProdSel(null);
    clearTimeout(timerBusq.current);
    timerBusq.current = setTimeout(()=>buscarProductos(v),300);
  };

  const seleccionarProducto = (p) => {
    setProdSel(p); setBusq(p.producto); setShowDrop(false);
  };

  const consultar = async () => {
  if(!prodSel){ return; }
  setCargando(true); setBuscado(true);
  try {
    const r = await api.get('/seguros/kardex/devoluciones',{
      params:{ ueId, medCod:prodSel.codigo, fechaInicio, fechaFin, fuente:fuente||null }
    });
    if(r.data.success) setDatos(r.data.data||[]);

  
    api.get('/seguros/kardex/total-prescrito',{
      params:{ ueId, medCod:prodSel.codigo, fechaInicio, fechaFin, fuente:fuente||null }
    }).then(r=>{ 
  if(r.data.success){
    setTotalPrescritoReal(Number(r.data.total||0));
    setPrescritoPorServicio(r.data.data||[]);
  }
})
      .catch(console.error);

  } catch(e){console.error(e);}
  finally{ setCargando(false); }
};



  const datosFiltrados = useMemo(()=>{
  let f = datos;
  if(busqTabla.trim()){
    const q = busqTabla.trim().toLowerCase();
    f = f.filter(d=>
      (d.dni||'').toLowerCase().includes(q)||
      (d.paciente||'').toLowerCase().includes(q)
    );
  }
  if(filtroFin) f = f.filter(d=>d.fuenteFinanciamiento===filtroFin);
  return f;
},[datos,busqTabla,filtroFin]);

  // KPIs
  const totPrescrito = totalPrescritoReal;
const totDevuelto  = useMemo(()=>datosFiltrados.reduce((s,d)=>s+Number(d.devuelto||0),0),[datosFiltrados]);
const totEntregado = useMemo(()=>totPrescrito - totDevuelto,[totPrescrito, totDevuelto]);
  

  // Gráfico por servicio
  const chartData = useMemo(()=>{
  // Servicios de devoluciones
  const mapDev = {};
  datosFiltrados.forEach(d=>{
    const s = d.servicio||'NO ESPECIFICADO';
    if(!mapDev[s]) mapDev[s]={devuelto:0};
    mapDev[s].devuelto += Number(d.devuelto||0);
  });

  // Servicios de prescritos
  const mapPres = {};
  prescritoPorServicio.forEach(p=>{
    mapPres[p.servicio] = Number(p.totalPrescrito||0);
  });

  // Unir todos los servicios
  const servicios = [...new Set([
    ...Object.keys(mapDev),
    ...Object.keys(mapPres)
  ])].sort((a,b)=>(mapPres[b]||0)-(mapPres[a]||0));

  return {
    labels: servicios,
    datasets:[
      {label:'Prescrito', data:servicios.map(s=>mapPres[s]||0),
        backgroundColor:`${IOS.blue}CC`,borderRadius:6,borderWidth:0},
      {label:'Devuelto',  data:servicios.map(s=>mapDev[s]?.devuelto||0),
        backgroundColor:`${IOS.red}CC`,borderRadius:6,borderWidth:0},
    ]
  };
},[datosFiltrados, prescritoPorServicio]);

  const chartOpts = useMemo(()=>({
  responsive:true, maintainAspectRatio:false,
  indexAxis: tipoGrafKardex==='barH' ? 'y' : 'x',
  plugins:{
    datalabels:{display:false},
    legend:{position:'bottom',labels:{usePointStyle:true,pointStyle:'circle',
      padding:16,color:IOS.label2,font:{size:11}}},
    tooltip:{backgroundColor:'rgba(28,28,30,0.92)',titleColor:'#fff',
      bodyColor:'rgba(255,255,255,0.75)',padding:10,borderRadius:10},
  },
  scales:{
  x:{
    stacked: tipoGrafKardex==='stacked',
    grid:{display:false},
    ticks:{font:{size:9},color:IOS.label2},border:{display:false}},
  y:{
    stacked: tipoGrafKardex==='stacked',
    grid:{color:'rgba(60,60,67,0.05)'},
    ticks:{font:{size:9},color:IOS.label2,maxTicksLimit:5},border:{display:false}},
},
}),[tipoGrafKardex]);

  return (
    <Box sx={{minHeight:'100vh',bgcolor:IOS.bg}}>
      <HeaderIOS titulo="Kardex Farmacia" subtitulo="Seguros"
        onHome={()=>navigate(`/${modulo}`)} onLogout={handleLogout}
        nombreCompleto={nf} avatarLetra={nf.charAt(0).toUpperCase()}/>

      <Box sx={{maxWidth:1400,mx:'auto',px:{xs:1.5,sm:2.6},pt:2.5,pb:6}}>

        {/* Filtros */}
        <Box sx={{bgcolor:IOS.surface,borderRadius:'16px',p:2,mb:2,
          boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`}}>
          <Box sx={{display:'flex',flexWrap:'wrap',gap:1.5,alignItems:'flex-end'}}>

            {/* Buscador producto */}
            <Box sx={{flex:'1 1 280px',maxWidth:380}} ref={dropRef}>
              <Typography sx={{fontSize:'0.6rem',fontWeight:700,color:IOS.label2,
                letterSpacing:'0.07em',textTransform:'uppercase',mb:0.5}}>Medicamento *</Typography>
              <Box sx={{position:'relative'}}>
                <Box sx={{position:'absolute',left:10,top:'50%',transform:'translateY(-50%)',
                  pointerEvents:'none',color:IOS.label2}}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
                  </svg>
                </Box>
                <input
                  value={busq}
                  onChange={handleBusq}
                  onFocus={()=>busq&&setShowDrop(true)}
                  placeholder="Buscar por nombre o código..."
                  style={{width:'100%',height:36,paddingLeft:30,paddingRight:36,
                    border:`1.5px solid ${prodSel?IOS.green:IOS.separator}`,
                    borderRadius:8,fontSize:'0.82rem',color:IOS.label,
                    backgroundColor:IOS.surface,outline:'none',
                    boxSizing:'border-box',fontFamily:'inherit'}}
                  onFocus_real={e=>e.target.style.borderColor=IOS.blue}
                />
                {cargProd&&(
                  <Box sx={{position:'absolute',right:10,top:'50%',transform:'translateY(-50%)'}}>
                    <CircularProgress size={13} sx={{color:IOS.blue}}/>
                  </Box>
                )}
                {prodSel&&!cargProd&&(
                  <Box sx={{position:'absolute',right:10,top:'50%',transform:'translateY(-50%)',
                    display:'flex',alignItems:'center'}}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                      stroke={IOS.green} strokeWidth="2.5" strokeLinecap="round">
                      <path d="M20 6L9 17l-5-5"/>
                    </svg>
                  </Box>
                )}

                {/* Dropdown resultados */}
                {showDrop&&productos.length>0&&(
                  <Box sx={{position:'absolute',top:'100%',left:0,right:0,zIndex:9999,
                    bgcolor:IOS.surface,border:`1px solid ${IOS.separator}`,
                    borderRadius:'12px',boxShadow:'0 8px 24px rgba(0,0,0,0.14)',
                    mt:0.5,maxHeight:220,overflowY:'auto',
                    '&::-webkit-scrollbar':{width:3},
                    '&::-webkit-scrollbar-thumb':{bgcolor:IOS.separator,borderRadius:4}}}>
                    {productos.map((p,i)=>(
                      <Box key={i}
                        onMouseDown={e=>{e.preventDefault();seleccionarProducto(p);}}
                        sx={{px:1.5,py:1,cursor:'pointer',
                          borderBottom:i<productos.length-1?`1px solid ${IOS.separator}`:'none',
                          '&:hover':{bgcolor:IOS.bg}}}>
                        <Typography sx={{fontSize:'0.62rem',fontWeight:700,
                          color:IOS.blue,fontFamily:'monospace',mb:0.1}}>{p.codigo}</Typography>
                        <Typography sx={{fontSize:'0.82rem',color:IOS.label,lineHeight:1.3}}>
                          {p.producto}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                )}
                {showDrop&&busq.length>=1&&productos.length===0&&!cargProd&&(
                  <Box sx={{position:'absolute',top:'100%',left:0,right:0,zIndex:9999,
                    bgcolor:IOS.surface,border:`1px solid ${IOS.separator}`,
                    borderRadius:'12px',boxShadow:'0 8px 24px rgba(0,0,0,0.14)',
                    mt:0.5,px:1.5,py:2,textAlign:'center'}}>
                    <Typography sx={{fontSize:'0.78rem',color:IOS.label2}}>Sin resultados</Typography>
                  </Box>
                )}
              </Box>
            </Box>

            {/* Fechas */}
            {[['Desde',fechaInicio,setFechaInicio],['Hasta',fechaFin,setFechaFin]].map(([lbl,val,set])=>(
              <Box key={lbl}>
                <Typography sx={{fontSize:'0.6rem',fontWeight:700,color:IOS.label2,
                  letterSpacing:'0.07em',textTransform:'uppercase',mb:0.5}}>{lbl}</Typography>
                <input type="date" value={val} onChange={e=>set(e.target.value)}
                  style={{height:36,padding:'0 10px',border:`1px solid ${IOS.separator}`,
                    borderRadius:8,fontSize:'0.8rem',color:IOS.label,
                    backgroundColor:IOS.surface,outline:'none',fontFamily:'inherit'}}
                  onFocus={e=>e.target.style.borderColor=IOS.blue}
                  onBlur={e=>e.target.style.borderColor=IOS.separator}/>
              </Box>
            ))}

            {/* Fuente */}
            <Box>
              <Typography sx={{fontSize:'0.6rem',fontWeight:700,color:IOS.label2,
                letterSpacing:'0.07em',textTransform:'uppercase',mb:0.5}}>Fuente</Typography>
              <select value={fuente} onChange={e=>setFuente(e.target.value)}
                style={{height:36,padding:'0 10px',border:`1px solid ${IOS.separator}`,
                  borderRadius:8,fontSize:'0.8rem',color:IOS.label,
                  backgroundColor:IOS.surface,outline:'none',
                  fontFamily:'inherit',minWidth:130}}>
                <option value="">Todas</option>
                <option value="SIS">SIS</option>
                <option value="ROR">ROR</option>
                <option value="SOAT">SOAT</option>
                <option value="PARTICULAR">PARTICULAR</option>
              </select>
            </Box>

            {/* Botón consultar */}
            <Box component="button" onClick={consultar} disabled={!prodSel||cargando}
              sx={{height:36,px:2.5,borderRadius:'10px',border:'none',
                bgcolor:!prodSel||cargando?'#E5E5EA':IOS.blue,
                cursor:!prodSel||cargando?'default':'pointer',
                display:'flex',alignItems:'center',gap:0.8,
                alignSelf:'flex-end',transition:'all 0.15s',
                '&:hover':{filter:!prodSel||cargando?'none':'brightness(0.9)'},
              }}>
              {cargando
                ? <CircularProgress size={13} sx={{color:'white'}}/>
                : <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="white" strokeWidth="2.2" strokeLinecap="round">
                    <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
                  </svg>
              }
              <Typography sx={{fontSize:'0.8rem',fontWeight:700,
                color:!prodSel||cargando?'#8E8E93':'white'}}>
                Consultar
              </Typography>
            </Box>
          </Box>

          {/* Chip producto seleccionado */}
          {prodSel&&(
            <Box sx={{mt:1.5,display:'flex',alignItems:'center',gap:0.8,
              p:1,bgcolor:`${IOS.green}08`,borderRadius:'10px',
              border:`1px solid ${IOS.green}25`}}>
              <Box sx={{width:6,height:6,borderRadius:'50%',bgcolor:IOS.green,flexShrink:0}}/>
              <Typography sx={{fontSize:'0.72rem',fontWeight:700,color:IOS.green,
                fontFamily:'monospace'}}>{prodSel.codigo}</Typography>
              <Typography sx={{fontSize:'0.72rem',color:IOS.label,flex:1,
                overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                {prodSel.producto}
              </Typography>
              <Box component="button" onClick={()=>{setProdSel(null);setBusq('');setDatos([]);}}
                sx={{width:20,height:20,borderRadius:'50%',border:'none',
                  bgcolor:`${IOS.green}20`,cursor:'pointer',display:'flex',
                  alignItems:'center',justifyContent:'center',flexShrink:0,
                  '&:hover':{bgcolor:`${IOS.green}35`}}}>
                <svg width="8" height="8" viewBox="0 0 24 24" fill="none"
                  stroke={IOS.green} strokeWidth="2.5" strokeLinecap="round">
                  <path d="M18 6L6 18M6 6l12 12"/>
                </svg>
              </Box>
            </Box>
          )}
        </Box>

        {cargando
          ? <Box sx={{py:10,textAlign:'center'}}><CircularProgress sx={{color:IOS.blue}}/></Box>
          : !buscado
            ? <Box sx={{py:10,textAlign:'center'}}>
                <Box sx={{width:56,height:56,borderRadius:'50%',bgcolor:`${IOS.blue}10`,
                  display:'flex',alignItems:'center',justifyContent:'center',mx:'auto',mb:2}}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke={IOS.blue} strokeWidth="1.5" strokeLinecap="round">
                    <path d="M9 3h10l2 4H7L9 3z"/><rect x="5" y="7" width="18" height="16" rx="2"/>
                    <path d="M14 11v6M11 14h6"/>
                  </svg>
                </Box>
                <Typography sx={{fontWeight:700,color:IOS.label,mb:0.5}}>
                  Busca un medicamento
                </Typography>
                <Typography sx={{color:IOS.label2,fontSize:'0.85rem'}}>
                  Selecciona un producto y rango de fechas para consultar el kardex
                </Typography>
              </Box>
            : <Box sx={{display:'flex',flexDirection:'column',gap:2}}>

    {/* Gráfico + KPIs lado a lado */}
    <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',md:'1fr 180px'},gap:2,alignItems:'stretch'}}>

      {/* Gráfico */}
      <Box sx={{bgcolor:IOS.surface,borderRadius:'16px',p:2,
  boxShadow:'0 1px 4px rgba(0,0,0,0.07)',
  border:`1px solid ${IOS.separator}`,
  overflow:'hidden'}}>
        <Box sx={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',mb:2}}>
  <Box>
    <Typography sx={{fontWeight:700,fontSize:'0.88rem',color:IOS.label,mb:0.2}}>
      Por Servicio
    </Typography>
    <Typography sx={{fontSize:'0.7rem',color:IOS.label2}}>Prescrito vs Devuelto</Typography>
  </Box>
  <Box sx={{display:'flex',gap:0.4,bgcolor:IOS.bg,borderRadius:'10px',p:0.4,flexShrink:0}}>
    {[
      {key:'bar', icon:<><rect x="3" y="10" width="4" height="8" rx="1" fill="currentColor"/><rect x="10" y="6" width="4" height="12" rx="1" fill="currentColor"/><rect x="17" y="3" width="4" height="15" rx="1" fill="currentColor"/></>},
      {key:'barH', icon:<><rect x="3" y="3" width="8" height="4" rx="1" fill="currentColor"/><rect x="3" y="10" width="12" height="4" rx="1" fill="currentColor"/><rect x="3" y="17" width="15" height="4" rx="1" fill="currentColor"/></>},
      {key:'stacked', icon:<><rect x="3" y="6" width="4" height="12" rx="1" fill="currentColor" opacity=".5"/><rect x="3" y="3" width="4" height="3" rx="1" fill="currentColor"/><rect x="10" y="9" width="4" height="9" rx="1" fill="currentColor" opacity=".5"/><rect x="10" y="6" width="4" height="3" rx="1" fill="currentColor"/><rect x="17" y="12" width="4" height="6" rx="1" fill="currentColor" opacity=".5"/><rect x="17" y="9" width="4" height="3" rx="1" fill="currentColor"/></>},

    ].map(({key,icon})=>(
      <Box key={key} onClick={()=>setTipoGrafKardex(key)}
        sx={{width:26,height:26,borderRadius:'7px',cursor:'pointer',
          display:'flex',alignItems:'center',justifyContent:'center',transition:'all 0.15s',
          bgcolor:tipoGrafKardex===key?IOS.surface:'transparent',
          boxShadow:tipoGrafKardex===key?'0 1px 3px rgba(0,0,0,0.12)':'none',
          color:tipoGrafKardex===key?IOS.blue:IOS.label2}}>
        <svg width="16" height="16" viewBox="0 0 24 24">{icon}</svg>
      </Box>
    ))}
  </Box>
</Box>
        <Box sx={{height:220}}>
          <Bar data={chartData} options={chartOpts}/>
        </Box>
      </Box>

      {/* KPIs verticales */}
      <Box sx={{display:'flex',flexDirection:'column',gap:1}}>
        <KpiCard label="Prescrito" valor={totPrescrito} color={IOS.blue}
          icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke={IOS.blue} strokeWidth="1.8" strokeLinecap="round">
            <path d="M9 3h10l2 4H7L9 3z"/><rect x="5" y="7" width="18" height="16" rx="2"/>
            <path d="M14 11v6M11 14h6"/>
          </svg>}/>
        <KpiCard label="Devuelto" valor={totDevuelto} color={IOS.red}
          icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke={IOS.red} strokeWidth="1.8" strokeLinecap="round">
            <path d="M9 10H4V5"/><path d="M4 10a10 10 0 1 1 2.34 9"/>
          </svg>}/>
        <KpiCard label="Entregado" valor={totEntregado} color={IOS.green}
          icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke={IOS.green} strokeWidth="1.8" strokeLinecap="round">
            <path d="M20 6L9 17l-5-5"/>
          </svg>}/>
      </Box>
    </Box>

    {/* Tabla */}
    <Box sx={{bgcolor:IOS.surface,borderRadius:'16px',
      boxShadow:'0 1px 4px rgba(0,0,0,0.07)',
      border:`1px solid ${IOS.separator}`,overflow:'hidden'}}>

      {/* Barra filtros tabla */}
      <Box sx={{px:2,py:1.5,borderBottom:`1px solid ${IOS.separator}`,
        display:'flex',gap:1.5,flexWrap:'wrap',alignItems:'center'}}>
        {/* Búsqueda DNI/Nombre */}
        <Box sx={{position:'relative',flex:'1 1 200px',maxWidth:280}}>
          <Box sx={{position:'absolute',left:9,top:'50%',
            transform:'translateY(-50%)',pointerEvents:'none',color:IOS.label2}}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
            </svg>
          </Box>
          <input
            value={busqTabla}
            onChange={e=>setBusqTabla(e.target.value)}
            placeholder="DNI o nombre del paciente..."
            style={{width:'100%',height:32,paddingLeft:26,paddingRight:10,
              border:`1px solid ${IOS.separator}`,borderRadius:8,
              fontSize:'0.78rem',color:IOS.label,
              backgroundColor:IOS.bg,outline:'none',
              boxSizing:'border-box',fontFamily:'inherit'}}
            onFocus={e=>e.target.style.borderColor=IOS.blue}
            onBlur={e=>e.target.style.borderColor=IOS.separator}/>
        </Box>
        {/* Filtro financiamiento */}
        <select value={filtroFin} onChange={e=>setFiltroFin(e.target.value)}
          style={{height:32,padding:'0 8px',border:`1px solid ${IOS.separator}`,
            borderRadius:8,fontSize:'0.78rem',color:IOS.label,
            backgroundColor:IOS.bg,outline:'none',
            fontFamily:'inherit',minWidth:130}}>
          <option value="">Todos los financ.</option>
          {[...new Set(datos.map(d=>d.fuenteFinanciamiento).filter(Boolean))].map(f=>(
            <option key={f} value={f}>{f}</option>
          ))}
        </select>
        {/* Contador */}
        <Box sx={{ml:'auto',px:1.2,py:0.4,bgcolor:IOS.bg,
          borderRadius:'20px',border:`1px solid ${IOS.separator}`}}>
          <Typography sx={{fontSize:'0.68rem',fontWeight:700,color:IOS.blue}}>
            {datosFiltrados.length}
          </Typography>
        </Box>
      </Box>

      <Box sx={{overflowX:'auto',overflowY:'auto',maxHeight:480,
        '&::-webkit-scrollbar':{width:4,height:4},
        '&::-webkit-scrollbar-thumb':{bgcolor:IOS.separator,borderRadius:4}}}>
        <table style={{width:'100%',borderCollapse:'collapse',
          fontSize:'0.75rem',minWidth:900}}>
          <thead><tr>
            <TH>Registro</TH><TH>Devolución</TH>
            <TH>Nº Documento</TH><TH>Financiamiento</TH>
            <TH w={80}>DNI</TH><TH>Paciente</TH>
            <TH>Responsable</TH><TH>Servicio</TH>
            <TH right w={80}>Prescrito</TH>
            <TH right w={80}>Devuelto</TH>
            <TH right w={80}>Entregado</TH>
          </tr></thead>
          <tbody>
            {datosFiltrados.length===0
              ?<tr><td colSpan={11} style={{padding:'32px',textAlign:'center',
                  color:IOS.label2,fontSize:'0.82rem'}}>
                Sin registros
              </td></tr>
              :datosFiltrados.map((d,i)=>(
                <tr key={i}
                  style={{borderBottom:`1px solid ${IOS.separator}`,
                    backgroundColor:IOS.surface,transition:'background 0.1s'}}
                  onMouseEnter={e=>e.currentTarget.style.backgroundColor=IOS.bg}
                  onMouseLeave={e=>e.currentTarget.style.backgroundColor=IOS.surface}>
                  <td style={{padding:'7px 10px',fontSize:'0.7rem',color:IOS.label2}}>{d.registro}</td>
                  <td style={{padding:'7px 10px',fontSize:'0.7rem',color:IOS.label2}}>{d.devolucion}</td>
                  <td style={{padding:'7px 10px',fontFamily:'monospace',fontSize:'0.7rem',color:IOS.label2}}>{d.documento}</td>
                  <td style={{padding:'7px 10px',fontSize:'0.7rem',color:IOS.label2}}>{d.fuenteFinanciamiento}</td>
                  <td style={{padding:'7px 10px',fontFamily:'monospace',fontSize:'0.68rem',color:IOS.label2}}>{d.dni}</td>
                  <td style={{padding:'7px 10px',fontSize:'0.72rem',color:IOS.label,maxWidth:160,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{d.paciente}</td>
                  <td style={{padding:'7px 10px',fontSize:'0.7rem',color:IOS.label2,maxWidth:130,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{d.responsable}</td>
                  <td style={{padding:'7px 10px',fontSize:'0.7rem',color:IOS.label2}}>{d.servicio}</td>
                  <td style={{padding:'7px 10px',textAlign:'right',fontWeight:700,color:IOS.blue}}>{Number(d.prescrito).toFixed(0)}</td>
                  <td style={{padding:'7px 10px',textAlign:'right',fontWeight:700,color:IOS.red}}>{Number(d.devuelto).toFixed(0)}</td>
                  <td style={{padding:'7px 10px',textAlign:'right',fontWeight:700,color:IOS.green}}>{Number(d.entregado).toFixed(0)}</td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </Box>
    </Box>
  </Box>
        }
      </Box>
    </Box>
  );
};

export default KardexFarmacia;